import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  forwardRef,
  inject,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SvgComponent } from '../svg/svg.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, map, tap } from 'rxjs';
import { ButtonComponent } from '../button/button.component';
import { TranslatePipe } from '@selfcare/cms';
import { AsyncPipe, NgClass, NgStyle } from '@angular/common';

@Component({
  selector: 'sc-input-password',
  imports: [SvgComponent, ButtonComponent, TranslatePipe, AsyncPipe, NgClass, NgStyle],
  templateUrl: './input-password.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPasswordComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputPasswordComponent implements ControlValueAccessor {
  readonly isFocusedChange = output<boolean>();

  placeholder = input<string>('');
  id = input<string>(null);

  isShow = false;
  value: string;
  isDisabled = false;
  public isFocused = false;
  autofocus = input(false);
  ariaInvalid = input(false);
  autocomplete = input<string>('');
  ariaDescribedBy = input<string>(null);
  public errorMessage = input<string>(null);

  inputRef = viewChild<ElementRef>('input');

  destroyRef = inject(DestroyRef);
  isValid = signal<boolean>(true);

  ngAfterViewInit() {
    if (this.autofocus()) {
      this.inputRef().nativeElement.focus();
    }

    const nativeElement = this.inputRef().nativeElement;
    fromEvent(nativeElement, 'input')
      .pipe(
        map(() => nativeElement.validity.valid),
        tap(this.isValid.set),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  toggleShow() {
    this.isShow = !this.isShow;
  }
  onChange = (value: any) => {};
  onTouched = () => {};

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }
  setDisabledState(disabled: boolean) {
    this.isDisabled = disabled;
  }

  writeValue(value: any) {
    this.value = value;
  }

  onInput(event: any) {
    this.onChange(event.target.value);
  }

  public onFocus() {
    this.isFocused = true;
    this.isFocusedChange.emit(true);
  }

  public onBlur() {
    this.isFocused = false;
    this.isFocusedChange.emit(false);
    this.onTouched();
  }
}
